import { fansupportPublic } from "../index";

export const getDocumentTypes = async ({ languageId }) => {
    return fansupportPublic.get('/document/types', {params: {
        languageId,
    }})
}